import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgClearFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 17"
    stroke="#007AFF"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.055 3.503A6.055 6.055 0 1 1 2 9.56" />
    <path d="M9.746 5.794 8.035 3.526l2.21-1.533" />
  </svg>
);
const Memo = memo(SvgClearFilter);
export default Memo;
